if (!customElements.get('estimated-delivery')) {
  class EstimatedDelivery extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        destinationRange: '.estimated-delivery__date',
        container: '.estimated-delivery'
      };

      this.months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ];
    }

    connectedCallback() {
      const container = this.querySelector(this.selectors.container);

      if (!container) return;

      this.optimisticDelivery = container.dataset.optimisticDelivery;
      this.pessimisticDelivery = container.dataset.pessimisticDelivery;

      this.getEstimations();

      this.unsubscribeVariantChange = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.#onVariantChange.bind(this)
      );
    }

    disconnectedCallback() {
      this.unsubscribeVariantChange?.();
    }

    #onVariantChange(event) {
      const variant = event?.data?.variant;

      if (!variant) return;

      this.updateEstimatedDeliveryVisibility(variant);
    }

    getEstimations() {
      const today = new Date();

      this.querySelectorAll(this.selectors.destinationRange).forEach((el) => {
        const optimisticDeliveryDate = this.calculateDeliveryDate(
          today,
          this.optimisticDelivery
        );

        const pessimisticDeliveryDate = this.calculateDeliveryDate(
          today,
          this.pessimisticDelivery
        );

        const optimisticFinal = this.formatDate(optimisticDeliveryDate);
        const pessimisticFinal = this.formatDate(pessimisticDeliveryDate);

        const splitDate = (dateString) => {
          const [day, month] = dateString.split(' ');

          return { day: parseInt(day, 10), month };
        };

        const optimisticDate = splitDate(optimisticFinal);
        const pessimisticDate = splitDate(pessimisticFinal);

        if (optimisticDate.day === pessimisticDate.day) {
          pessimisticDate.day += 1;
        }

        const updatedPessimisticFinal = `${pessimisticDate.day} ${pessimisticDate.month}`;

        if (optimisticFinal == pessimisticFinal) {
          el.textContent = `${optimisticFinal} - ${updatedPessimisticFinal}`;
        } else {
          el.textContent = `${optimisticFinal} - ${pessimisticFinal}`;
        }
      });
    }

    updateEstimatedDeliveryVisibility(variant) {
      const component = this.querySelector(this.selectors.container);

      if (!component) return;

      component.hidden = !variant.available;
    }

    calculateDeliveryDate(today, shippingDays) {
      const outOfHours = today.getHours() > 16 ? 1 : 0;
      const totalDaysToAdd = parseInt(shippingDays, 10) + outOfHours;

      const deliveryDate = new Date(
        today.getTime() + totalDaysToAdd * 24 * 60 * 60 * 1000
      );

      return this.calculateWeekends(deliveryDate);
    }

    calculateWeekends(today) {
      let cutoutDays = 0;

      switch (today.getDay()) {
        case 6: // Saturday
          cutoutDays += 2;
          break;
        case 0: // Sunday
          cutoutDays += 1;
          break;
        default:
          break;
      }

      return new Date(today.setDate(today.getDate() + cutoutDays));
    }

    formatDate(date) {
      return `${date.getDate()} ${this.months[date.getMonth()]}`;
    }
  }

  customElements.define('estimated-delivery', EstimatedDelivery);
}
